import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["status", "testId"];
import React from 'react';
import { SmartLinkStatus } from '../../../../../constants';
import AIFooterBlockResolvedView from './resolved';
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */
var AIFooterBlock = function AIFooterBlock(_ref) {
  var status = _ref.status,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-ai-footer-block' : _ref$testId,
    props = _objectWithoutProperties(_ref, _excluded);
  if (status !== SmartLinkStatus.Resolved) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AIFooterBlockResolvedView, _extends({}, props, {
    testId: testId
  }));
};
export default AIFooterBlock;